export const fontWeights = {
  body: 400,
  normal: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  heading: 700,
  black: 900,
}
